import PropTypes from 'prop-types';
import React from 'react';
import Layout from '../../components/Layout/Layout';
import SEO from '../../components/SEO/SEO';
import Heading from '../../components/Heading/Heading';
import Content from '../../components/Content/Content';
import theme from '../../styles/theme';
import CTACardv2 from '../../components/CTACardv2/CTACardv2';

function Accessibility({ isLoading = false }) {
  return (
    <Layout isLoading={isLoading}>
      <SEO
        title='Accessibility'
        description='Accessibility at Vanderbilt Mortgage and Finance, Inc.'
      />

      <Heading background={theme.colors.blue10} appearance='dark'>
        <h1>Accessibility</h1>
      </Heading>

      <Content divider={false}>
        <h2>Online Accessibility Policy</h2>

        <p className='color-grey1 no-margin-top'>
          Vanderbilt Mortgage and Finance, Inc. is committed to providing
          excellent service to all of our customers, including those with
          disabilities. We strive to provide products and services to those with
          disabilities in a way that respects their dignity and independence.
        </p>
        <p className='color-grey1 no-margin-top'>
          To accomplish this, Vanderbilt Mortgage and Finance, Inc. has based
          our web accessibility standards on the Americans with Disabilities
          Act’s Best Practices Tool Kit for State and Local Governments. We
          believe our continued work toward conforming to this standard will
          provide our customers with accessible content and a remarkable
          experience.
        </p>
        <p className='color-grey1 no-margin-top'>
          Here are some steps we are taking toward providing more accessible web
          content:
        </p>
        <ul>
          <li>
            Staff and resources dedicated entirely to digital accessibility,
            performing multi-layer accessibility testing and analysis of new and
            updated web content
          </li>
          <li>
            Training our team members to make accessible design and development
            a fundamental element of all web content
          </li>
        </ul>
        <p className='color-grey1 no-margin-top'>
          Our ultimate goal is to exceed the expectations of all of our
          customers. Comments on our services regarding how well those
          expectations are being met are welcome and appreciated. Feedback can
          be provided in the following ways:
        </p>

        <h3 className='type-h4 color-bedtime margin-top-8 margin-bottom-2'>
          By Email:
        </h3>
        <p className='color-grey1 no-margin-top'>
          For accessibilty issues, email our support team at{' '}
          <span>
            <a href='mailto:customercare@vmf.com'>customercare@vmf.com</a>
          </span>
        </p>

        <h3 className='type-h4 color-bedtime margin-top-8 margin-bottom-2'>
          By Phone:
        </h3>
        <p className='color-grey1 no-margin-top'>
          For technical accessibility issues, contact our support team. Call{' '}
          <a href='tel:18667010467'>1‑866‑701‑0467</a>.
        </p>

        <h3 className='type-h4 color-bedtime margin-top-8 margin-bottom-2'>
          By Mail:
        </h3>
        <p className='color-grey1 no-margin-top'>
          Please send any comments, questions, or concerns to the following
          address:
        </p>
        <p className='color-grey1 no-margin-top'>
          Vanderbilt Mortgage and Finance, Inc.
          <br />
          Attention: Digital Accessibility
          <br />
          500 Alcoa Trail
          <br />
          Maryville, TN 37804
          <br />
        </p>
      </Content>

      <CTACardv2
        preHeaderContent={'Have Questions?'}
        headerContent={`We're Here to Help`}
        buttonText={'Contact Us'}
        buttonUrl={'/contact-us/'}
        gtmClassName={'contact'}
        ctaIntro={
          <>
            <p>
              Existing customers <a href='tel:1-800-970-7250'>1-800-970-7250</a>
            </p>
            <p>
              New customers <a href='tel:1-866-701-0467'>1-866-701-0467</a>
            </p>
          </>
        }
      />
    </Layout>
  );
}

Accessibility.propTypes = {
  match: PropTypes.object,
  history: PropTypes.object,
  location: PropTypes.object,
  data: PropTypes.shape({}),
  error: PropTypes.object,
};

export default Accessibility;
